export const formatPhoneNumber = (str?: string) => {
  if (!str) {
    return '';
  }
  const cleaned = ('' + str).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{3})$/);
  if (match) {
    return `${match[1]} ${match[2]} ${match[3]}`;
  }

  return null;
};
